import React from 'react'
import ReactDom from 'react-dom'

import App from './app'

ReactDom.render(
  <App />,
  document.getElementById('app')
)